import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FaArrowLeft } from "react-icons/fa";
import { fetchData } from "../utils/fetchData";
import Project from "../components/Project";
import { Link } from "react-router-dom";

const Work = () => {
  const [works, setWorks] = useState([]);
  const URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const getWork = async () => {
      let workData = [];
      workData = await fetchData(`${URL}/works/`);
      setWorks(workData);
      console.log("work page:", workData);
    };
    getWork();
  }, [URL]);

  return (
    <>
      <div className="app__projects-all">
        <motion.div
          className="app__projects"
          whileInView={{ y: [100, 50, 0], opacity: [0, 0, 1] }}
          transition={{ duration: 0.5 }}
        >
          <div className="prev-pg">
            <Link to="/" className="prev-pg-link">
              <FaArrowLeft />
            </Link>
          </div>

          <div className="app__projects-heading">
            <div className="projects__heading-text">
              <h2 className="head-text">
                <span className="p-ctext">#</span>Projects
              </h2>
              <div className="horizontal-line"></div>
            </div>
          </div>
          <div className="app__projects-container">
            {works &&
              works.map((work) => (
                <>
                  <Project work={work} />
                </>
              ))}
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default Work;
